const partners: { thumbnail: string; name: string }[] = [
  {
    thumbnail: "partners/iteda.png",
    name: "ITEDA",
  },
  {
    thumbnail: "partners/tiec.png",
    name: "TIEC",
  },
  {
    thumbnail: "partners/Creativa Logo .PNG",
    name: "CREATIVA",
  },
  // {
  //   thumbnail: "partners/MQR.png",
  //   name: "MQR",
  // },
  {
    thumbnail: "partners/AICL.png",
    name: "AICL",
  },
];

const Partners = () => {
  return (
    <section>
      <div className="container my-10">
        <h2 className="text-center text-sm font-semibold uppercase tracking-wide text-slate-600">
          Trusted by the world's most innovative teams
        </h2>

        <div>
          <div className="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-4">
              {partners.map((partner, i) => (
                <div key={i} className="flex justify-center">
                  <picture>
                    <source srcSet={`/images/${partner.thumbnail}`} type="image/png" />
                    <img
                      className="h-14 grayscale transition-colors duration-300 hover:grayscale-0 dark:grayscale-0"
                      src={`/images/${partner.thumbnail}`}
                      alt={partner.name}
                    />
                  </picture>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
